<script lang="ts">
	import { goto } from '$app/navigation';
	import { afterUpdate } from 'svelte';
	import ArrowIcon from 'assets/svg/arrowLeft.svg?component';
	import { pagination } from 'utils/pagination';

	export let totalCount = 0;
	export let currentPage = 1;
	export let pageSize = 1;
	export let siblingCount = 1;
	export let dark: boolean;
	export let page = '/';
	export let urlParamsString = '';
	export let noNavigation = false;

	const linkBuilder = (number) => {
		return noNavigation ? null : `${page}?page=${number}${urlParamsString}`;
	};

	const gotoLink = (link) => {
		if (noNavigation) return;
		void goto(linkBuilder(link));
		document.body.scrollIntoView();
	};

	let paginationRange = pagination(totalCount, pageSize, siblingCount, currentPage);
	afterUpdate(() => {
		paginationRange = pagination(totalCount, pageSize, siblingCount, currentPage);
	});

	$: lastPage = paginationRange.length > 0 ? paginationRange[paginationRange.length - 1] : 1;
</script>

{#if totalCount > 0}
	<nav aria-label="pagination" class="pagination-block">
		<ul class="pagination no-select" class:dark>
			<li>
				<a
					on:click={(e) => {
						e.preventDefault();
						if (currentPage > 1) {
							currentPage -= 1;
							gotoLink(currentPage);
						}
					}}
					class="arrow-link"
					aria-label="Previous page"
					href={linkBuilder(currentPage === 1 ? currentPage : currentPage - 1)}
				>
					<ArrowIcon
						width={7}
						height={16}
						class={`arrow-icon center ${currentPage === 1 ? 'inactive' : 'active'}`}
					/>
				</a>
			</li>

			{#each paginationRange as pageNumber}
				{#if pageNumber === '...'}
					<li class="dots">{pageNumber}</li>
				{:else}
					<li class="item" class:selected={pageNumber === currentPage}>
						<a
							on:click={(e) => {
								e.preventDefault();
								if (pageNumber !== currentPage) {
									currentPage = Number(pageNumber);
									gotoLink(currentPage);
								}
							}}
							class="link"
							aria-label={pageNumber === currentPage ? `page ${pageNumber}` : null}
							aria-current={pageNumber === currentPage ? 'page' : null}
							href={linkBuilder(pageNumber)}
						>
							{pageNumber}
						</a>
					</li>
				{/if}
			{/each}

			<li>
				<a
					on:click={(e) => {
						e.preventDefault();
						if (currentPage !== lastPage) {
							currentPage += 1;
							gotoLink(currentPage);
						}
					}}
					class="arrow-link"
					aria-label="Next page"
					href={linkBuilder(currentPage === lastPage ? currentPage : currentPage + 1)}
				>
					<ArrowIcon
						width={7}
						height={16}
						class={`arrow-icon rotate center ${currentPage === lastPage ? 'inactive' : 'active'}`}
					/>
				</a>
			</li>
		</ul>
	</nav>
{/if}

<style lang="scss">
	@import 'pagination';
</style>
